export default {
    searchList: {
        searchTxt: [
            {
                name: '供应商编码',
                value: 'supplierCode',
                type: 'input',
                unfold: true,
                span: 4,
                multiple: false,
            },
            {
                name: '供应商名称',
                value: 'supplierNameCn',
                type: 'input',
                unfold: true,
                span: 4,
                multiple: false,
            },
            {
                name: '主体性质',
                value: 'propertyNature',
                type: 'select',
                optionNum: 'SYS_SUPPLIERS_PROPERTY',
                unfold: true,
                span: 4,
            },
            {
                name: '供应商类型',
                value: 'supplierType',
                type: 'select',
                unfold: true,
                optionNum: 'SYS_SUPPLIERS_TYPE',
                span: 4,
                multiple: true,
            },
            {
                name: '供应商状态',
                value: 'supplierStatus',
                type: 'select',
                unfold: true,
                optionNum: 'SYS_SUPPLIERS_STATUS',
                span: 4,
            },
            {
                name: '涉外业务类型',
                value: 'isOverseas',
                type: 'select',
                unfold: true,
                optionNum: 'SRM_IS_OVERSEAS',
                span: 4,
            },
            {
                name: '创建时间',
                value: 'createTimeArr',
                type: 'time',
                unfold: true,
                span: 6,
            },
            {
                name: '业务类型状态',
                value: 'businessTypeStatus',
                type: 'select',
                unfold: false,
                optionNum: 'SYS_SUPPLIER_SERVICES_STATUS',
                span: 4,
                multiple: true,
            },
            {
                name: '承运商类别',
                value: 'transType',
                type: 'select',
                unfold: false,
                optionNum: 'SRM_SHIPPER_TYPE',
                span: 3,
                multiple: true,
            },
            {
                name: '是否直采专线',
                value: 'isSelfManage',
                type: 'select',
                unfold: false,
                optionNum: 'LESS_THAN_TAG',
                span: 4,
            },
            {
                name: '分公司',
                value: 'companyNameCn',
                unfold: false,
                advanceConfig: [
                    { prop: 'companyNameCn', value: '分公司名称' },
                    { prop: 'companyCode', value: '分公司编码' },
                ],
                tableConfig: [
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                advanceUrl: '/esCompany/popCompany',
                type: 'advance',
                cbParams: ['companyCode#companyCode', 'companyNameCn#companyNameCn'],
                span: 3,
                multiple: true,
                multipleTableColumn: { prop: 'companyNameCn', value: '分公司名称' },
            },
            {
                name: '身份证号',
                value: 'idCard',
                type: 'input',
                unfold: false,
                span: 3,
            },
            {
                name: '集团编号',
                value: 'supplierCodeGroup',
                type: 'input',
                unfold: false,
                span: 3,
                multiple: false,
            },
        ],
        unfoldState: false,
        advancedBtn: true,
    },
    searchTotalTitle: [
        {
            name: '业务类型',
            value: 'businessType',
            type: 'select',
            optionNum: 'SRM_BUSYNESS_TYPE_BACKGROUND',
            unfold: true,
            span: 3,
            multiple: false,
        },
        // {
        //     'name': '承运商类别',
        //     'value': 'transType',
        //     'type': 'select',
        //     'optionNum': 'SU_SHIPPER_TYPE',
        //     'unfold': true,
        //     'span': 3,
        //     'multiple': false
        // },
        {
            name: '租赁商类别',
            value: 'lesseeType',
            type: 'select',
            optionNum: 'SU_LEASE_TYPE',
            unfold: true,
            span: 3,
            multiple: false,
        },
        // {
        //     'name': '变更申请状态',
        //     'value': 'updateFlag',
        //     'type': 'select',
        //     'optionNum': 'SYS_SU_CHANGE_STATUS',
        //     'unfold': true,
        //     'span': 3,
        //     'multiple': false
        // },
        {
            name: '是否黑名单',
            value: 'blackFlag',
            type: 'select',
            optionNum: 'SRM_BLACK_FLAG',
            unfold: true,
            span: 3,
            multiple: false,
        },
        {
            name: '合作方式',
            value: 'corporateType',
            type: 'select',
            optionNum: 'SU_CORPORATE_TYPE',
            unfold: true,
            span: 3,
            multiple: true,
        },
    ],
    table: {
        switchType: false,
        tableCut: false,
        clickState: true,
        selectBtn: true,
        height: 'calc(100vh - 230px)',
        columns: [
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '150px',
            },
            {
                label: '集团编号',
                prop: 'supplierCodeGroup',
                width: '150px',
            },
            {
                label: '供应商名称',
                prop: 'supplierNameCn',
                width: '150px',
            },
            {
                label: '供应商类型',
                prop: 'supplierTypeName',
                width: '150px',
            },
            {
                label: '供应商状态',
                prop: 'supplierStatus',
                width: '150px',
            },
            {
                label: '主体性质',
                prop: 'propertyNature_',
                width: '150px',
            },
            {
                label: '涉外业务类型',
                prop: 'isOverseas_',
                width: '150px',
            },
            {
                label: '业务类型',
                prop: 'businessType_',
                width: '150px',
            },
            {
                label: '分公司',
                prop: 'companyName',
                width: '150px',
            },
            {
                label: '业务类型状态',
                prop: 'businessTypeStatus_',
                width: '150px',
            },
            {
                label: '承运商类别',
                prop: 'transType',
                width: '150px',
            },
            {
                label: '自有车数量',
                prop: 'ownerCarNum',
                width: '100px',
            },
            {
                label: '租赁商类别',
                prop: 'lesseeType',
                width: '150px',
            },
            {
                label: '注册资金（万元）',
                prop: 'registerCapital',
                width: '150px',
            },
            {
                label: '合作方式',
                prop: 'corporateType',
                width: '150px',
            },
            {
                label: '运输方式',
                prop: 'transportType',
                width: '150px',
            },
            {
                label: '注册时间',
                prop: 'registerDate',
                width: '150px',
            },
            {
                label: '是否变更',
                prop: 'updateFlag',
                width: '150px',
            },
            {
                label: '是否黑名单',
                prop: 'blackFlag',
                width: '150px',
            },
            {
                label: '是否特批',
                prop: 'specialFlag',
                width: '150px',
            },
            {
                label: '整改期限',
                prop: 'rectifyPlanDate',
                width: '150px',
            },
            {
                label: '是否整改完成',
                prop: 'rectifyFlag',
                width: '150px',
            },
            {
                label: '资质是否齐全',
                prop: 'qualityIsComplete',
                width: '150px',
            },
            {
                label: '供应商名称简称',
                prop: 'supplierSimpleName',
                width: '120px',
            },
            {
                label: '服务类型',
                prop: 'serviceType',
                type: 'select',
                optionNum: 'SRM_SERVICE_TYPE',
                width: '100px',
            },
            {
                label: '创建人',
                prop: 'createUserName',
                width: '150px',
            },
            {
                label: '创建时间',
                prop: 'createTime',
                width: '150px',
            },
            {
                label: '更新时间',
                prop: 'updateTime',
                width: '150px',
            },
            {
                label: '关联公司自有车数量',
                prop: 'relevanceCarNumber',
                width: '150px',
            },
            {
                label: '服务平台',
                prop: 'siteName',
                width: '150px',
            },
        ],
        leftOperation: false,
        leftWidth: 250,
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
    },
}
